module.exports = __webpack_public_path__ + "static/media/lab-badge.f2c41d52.png";